import Searcher from './Searcher'
import { decorate, observable } from 'mobx';

class NoInlineResultSearcher extends Searcher {
    viewerType = 'no_inline_results';
    noInlineResults = true;

    constructor(params) {
        super(params);
        this.results = null;
        this.numResults = 0;
    }

    searchInternal(value, store) { 
        this.state="ongoing"
        this.error = null;
        this.unsupportMsg = null;
        this.unsupportMsgList = null;
        this.fillTargetWebsiteUrl(value, store);
        let promise1 = new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve('foo');
            }, 1);
          });
        return promise1
            .then(response => {
                this.state="successful"
            }).catch(err => {
                console.log(err);
                this.fillError(err);        
            });
            
    }
        
}



decorate(NoInlineResultSearcher, {
    viewerType: observable
})
export default NoInlineResultSearcher;